angular.module("app.constants", [])

.constant("version", "0.0.81")

;